import React from 'react';

import { DODGER_BLUE, WHITE } from '@constant/colors';

const Animated = () => (
  <svg viewBox="0 0 70 45">
    <defs>
      <circle id="a" cx="18" cy="22" r="3" />
      <circle id="b" cx="54" cy="25" r="3" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <rect fill={DODGER_BLUE} width="70" height="45" rx="5" />
      <path
        d="M17.026 22.35s9.53 11.25 18 0 18 0 18 0"
        stroke={WHITE}
        strokeWidth="2"
        strokeLinecap="square"
      />
      <use fill={WHITE} xlinkHref="#a" />
      <circle stroke={DODGER_BLUE} strokeWidth="2" cx="18" cy="22" r="4" />
      <g>
        <use fill={WHITE} xlinkHref="#b" />
        <circle stroke={DODGER_BLUE} strokeWidth="2" cx="54" cy="25" r="4" />
      </g>
    </g>
  </svg>
);

export default Animated;
